export default {
  isOk: false
};